import React from 'react';
import { get } from 'lodash';
import axios from 'axios';

import {
  CSRF_TOKEN,
  requestCallback,
} from '../../lib/helpers';

import TableHeader from '../TableHeader'

class DefaultsTable extends React.Component {
  static defaultProps = {
    settings: [],
    title: 'Default Settings'
  }

  state = {
    isSubmitted: false
  }

  turnOn = (setting) => this.changeSetting(setting, true)

  turnOff = (setting) => this.changeSetting(setting, false)

  changeSetting = (setting, value) => {
    if(this.state.isSubmitted) {
      return
    }

    this.setState({ isSubmitted: true }, () => {
      requestCallback(axios.put(`/${gon.currentProvider}/api/default_settings/${setting.title}`, {
        value: value,
        authenticity_token: CSRF_TOKEN,
      }))
    })
  }

  render = () => {
    const { settings, title } = this.props

    return (
      <div className='Section'>
        <div className='MainHeader MainHeader--flexible'>
          <h3 className='MainHeader__h3'>{title}</h3>
          <p className='MainHeader__left__p'>Change will affect new users</p>
        </div>

        <div className='Table Table--settings-defaults-list'>
          {(() => {
            const columnHeaders = [
              {
                label: 'Setting name',
              },
              {
                label: 'Action',
              },
              {
                label: '',
              }
            ]

            return (
              <div className='Table__row'>
                {columnHeaders.map((header, key) => (
                  <TableHeader
                    key={key}
                    header={header}
                  />
                ))}
              </div>
            )
          })()}

          {settings.map((setting) => (
            <div className={'Table__row'} key={setting.title}>
              <div className='Table__col'>{setting.title}</div>
              <div className='Table__col'>
                {get(setting, 'value') ?
                    <button type='button' className='Button Button--transparent Button--block'>
                      <span className='Badge Badge--block'>ON</span>
                    </button>
                  :
                    <button type='button' className='Button Button--transparent Button--block' onClick={() => this.turnOn(setting)}>
                      <span className='Badge Badge--gray-light Badge--block'>ON</span>
                    </button>
                  }
              </div>
              <div className='Table__col'>
                {get(setting, 'value') ?
                    <button type='button' className='Button Button--transparent Button--block' onClick={() => this.turnOff(setting)}>
                      <span className='Badge Badge--gray-light Badge--block'>OFF</span>
                    </button>
                  :
                    <button type='button' className='Button Button--transparent Button--block'>
                      <span className='Badge Badge--red Badge--block'>OFF</span>
                    </button>
                  }
              </div>
            </div>
          ))}
        </div>
      </div>
    );
  }
}

export default DefaultsTable
